import React from "react";

import Spinner from "react-bootstrap/Spinner";

const AndromedaLoader = () => {
  return (
    <div>
      <Spinner animation="border" style={{ color: "var(--accentColor)" }} />
    </div>
  );
};

export default AndromedaLoader;
